import Vue from "vue";
import FilterPage from "./FilterPage";
import InstantSearch from 'vue-instantsearch';

Vue.config.productionTip = false;

Vue.use(InstantSearch);

new Vue({
    el: "filter-page",
    components: {
        FilterPage,
    },
    created() {
        const skeleton = document.getElementById("filter-skeleton")
        if (skeleton) {
            skeleton.style.display = "none"
        }
    }
});
